import { render } from "./CompPagination.vue?vue&type=template&id=53701ebc"
import script from "./CompPagination.vue?vue&type=script&lang=js"
export * from "./CompPagination.vue?vue&type=script&lang=js"

import "./CompPagination.vue?vue&type=style&index=0&id=53701ebc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__